import { Observable } from 'rxjs';
import { ignoreElements } from 'rxjs/operators';

/**
 * A wrapper for an epic that allows to skip an epic requirement to return a redux action:
 *
 * const epic = (action$) => ignore(action$.pipe(tap(console.log)));
 */
export const ignore = (stream: Observable<unknown>) => stream.pipe(ignoreElements());
